/**
 * @fileoverview PUT handler for the "/sdk/debugger/:recording_id/stop" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { sdkDebuggerRecordingIdStopCacheKeys } from "./constants";
import type { PutSdkDebuggerRecordingIdStopProps, SdkDebuggerRecordingIdStopResult } from "./types";

export const putSdkDebuggerRecordingIdStop = reactQueryMutationAdapter(
  sdkDebuggerRecordingIdStopCacheKeys,
  ({ recordingId }: PutSdkDebuggerRecordingIdStopProps): Promise<SdkDebuggerRecordingIdStopResult> => {
    return fetch(`/sdk/debugger/${recordingId}/stop`, "PUT", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
